import { createSlice } from "@reduxjs/toolkit";

export const profileSlice = createSlice({
  name: "profile",
  initialState: {
    init: false,
    user: null,
    selectedModal: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.init = true;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
  },
});

export const { setUser, updateUser, setSelectedModal } = profileSlice.actions;

export default profileSlice.reducer;
